import React from "react";
import { RxCrossCircled } from "react-icons/rx";
import { IoMdCheckmarkCircleOutline } from "react-icons/io";
import { FaExternalLinkAlt } from "react-icons/fa";
import { Link } from "react-router-dom";
import { servicesImages } from "../../../config";
import { routeNames } from "../../../routes/routeNames";
import ContactButton from "../../MainComponents/ContactButton";

const BookAppointmentSection = ({ showImages = true, mainImage = servicesImages.accident }) => {
  return (
    <section className="bg-white py-12 px-4 md:px-8 lg:px-16">
      <div className="flex flex-col-reverse lg:flex-row items-center justify-center space-y-6 lg:space-y-0 lg:space-x-6">
        {/* Image Section */}
        {showImages && (
          <div className="w-full mt-10 lg:mt-0 lg:w-1/2">
            <div className="w-full h-64 md:h-96 lg:h-auto overflow-hidden flex justify-center items-center">
              <img
                src={mainImage}
                alt="Pain Relief"
                className="object-cover h-full w-auto rounded-md mx-auto"
              />
            </div>
          </div>
        )}

        {/* Text Section */}
        <div className="w-full p-5 lg:w-1/2 ">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-primary mb-4 lg:text-left">
            Don’t Let Chronic Pain<br/>Keep You from Moving Forward
          </h2>
          <p className="text-gray-700 text-base md:text-lg w-full md:w-[90%] lg:w-[80%] mx-auto lg:mx-0 mb-6">
            Experiencing pain can be both frustrating and stressful, often leading to limitations in your daily life. Without effective pain management, these issues can escalate and impact various aspects of your well-being.
          </p>
          <ul className="list-none space-y-2 text-gray-700 text-left">
            <li className="flex items-center lg:justify-start">
              <RxCrossCircled className="mr-2 text-primary" /> Reduced mobility
            </li>
            <li className="flex items-center lg:justify-start">
              <RxCrossCircled className="mr-2 text-primary" /> Intensified pain and discomfort
            </li>
            <li className="flex items-center lg:justify-start">
              <RxCrossCircled className="mr-2 text-primary" /> An overall diminished quality of life
            </li>
          </ul>

            {/* Button Section */}
            <ContactButton
            mainContStyle={
              "mt-10 flex flex-col justify-start sm:flex-row  items-center space-y-4 sm:space-y-0 sm:space-x-4"
            }
            bookOnlinestyle={
              "bg-primary text-white py-4 px-8 rounded-full font-semibold text-center"
            }
            callButtonStyle={
              "bg-orange text-white py-4 px-8 rounded-full font-semibold text-center"
            }
          />
            
         
        </div>
      </div>
    </section>
  );
};

export default BookAppointmentSection;